import { GivelifyTextField } from '@givelify/givelify-ui';
import { Grid, styled } from '@mui/material';

export const MatchHintText = styled('div')({
    fontSize: 14,
});

export const Autocomplete = styled('div')(({ theme }) => ({
    backgroundColor: theme.legacy.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    '&:focus-within': {
        boxShadow: '0 0 0',
        border: 0,
        borderRadius: '25px',
    },
    '& .MuiInput-input': {
        border: 'none',
        backgroundColor: theme.legacy.palette.background.paper,
    },
}));

export const AutocompleteInput = styled(GivelifyTextField)(({ theme }) => ({
    '& .MuiInputBase-root': {
        border: '1px solid #D8D8D8',
        borderRadius: '25px',
        paddingRight: '16px !important',
        paddingLeft: theme.spacing(2),
        paddingBottom: 0,
        height: 40,
        '&:focus-within': {
            boxShadow: '0 0 0',
        },
    },
    '&:focus': {
        border: 'none',
        outline: 0,
        boxShadow: 'none',
    },
    '& .MuiInputBase-input': {
        paddingLeft: '16px !important',
        '&:focus': {
            outline: 0,
            border: 'none',
            boxShadow: '0 0 0',
        },
    },
}));

export const SearchContent = styled(Grid)({
    marginLeft: 'auto',
});

export const AutocompletePopper = styled('div')({
    display: 'none',
});
